import { useQuery } from "@/api/swr/useQuery";
import { answerSubCategoryDetailSchema } from "@/schema/console/checking-assessments/AnswerSubCategoryDetail";

type Config = Parameters<
  typeof useQuery<typeof answerSubCategoryDetailSchema>
>[2];

export function useGetReAssessmentSubCategory(id: string, config?: Config) {
  return useQuery(
    answerSubCategoryDetailSchema,
    `/console/re_assessments/answer_sub_categories/${id}`,
    config,
  );
}
